module.exports = __webpack_public_path__ + "img/common_attunement_image.56beb7df.png";